import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _OPERATORS_VS_LABELS, _FILTER_VS_SYMBOL;

var IN = 'IN';
var NIN = 'NIN';
var GT = 'GT';
var GTE = 'GTE';
var LT = 'LT';
var LTE = 'LTE';
var BTW = 'BTW';
var BOOL = 'BOOL';
var LIKE = 'LIKE';
var EXISTS = 'EXISTS';
var CONTAINS = 'CONTAINS';
var NOT_CONTAINS = 'NOT_CONTAINS';
var BTW_INCLUSIVE = 'BTW_INCLUSIVE';
var NOT_EXISTS = 'NOT_EXISTS';
var EQ = 'EQ';
var NEQ = 'NEQ';
var SCRIPT = 'SCRIPT';
var OPERATORS = {
  IN: IN,
  NIN: NIN,
  GT: GT,
  GTE: GTE,
  LT: LT,
  LTE: LTE,
  BTW: BTW,
  BOOL: BOOL,
  EXISTS: EXISTS,
  CONTAINS: CONTAINS,
  NOT_CONTAINS: NOT_CONTAINS,
  BTW_INCLUSIVE: BTW_INCLUSIVE,
  NOT_EXISTS: NOT_EXISTS,
  EQ: EQ,
  NEQ: NEQ,
  SCRIPT: SCRIPT,
  LIKE: LIKE
};
export var OPERATORS_VS_LABELS = (_OPERATORS_VS_LABELS = {}, _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.IN, __('In')), _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.NIN, __('Not in')), _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.EQ, __('Equals')), _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.NEQ, __('Not Equals')), _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.BTW, __('Between')), _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.LT, __('Less than')), _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.LTE, __('Less than Equals')), _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.GT, __('Greater than')), _defineProperty(_OPERATORS_VS_LABELS, OPERATORS.GTE, __('Greater than Equals')), _OPERATORS_VS_LABELS);
export var FILTER_VS_SYMBOL = (_FILTER_VS_SYMBOL = {}, _defineProperty(_FILTER_VS_SYMBOL, OPERATORS.GT, '>'), _defineProperty(_FILTER_VS_SYMBOL, OPERATORS.GTE, '>='), _defineProperty(_FILTER_VS_SYMBOL, OPERATORS.LT, '<'), _defineProperty(_FILTER_VS_SYMBOL, OPERATORS.LTE, '<='), _defineProperty(_FILTER_VS_SYMBOL, OPERATORS.IN, '=='), _FILTER_VS_SYMBOL);
export default OPERATORS;